import emergAccident from '../../assets/emergency/accident_help.jpg';
import emergRoadside from '../../assets/emergency/roadside_Assistance.jpg';
import emergTowing from '../../assets/emergency/towing_assistance.jpg';
import emergLockout from '../../assets/emergency/vehicle_lockout.jpg';
import legalConsultation from '../../assets/legal_immigration_Assistance/legal_consultation.jpg';
import legalTraffic from '../../assets/legal_immigration_Assistance/traffic_ticket.jpg';
import legalFraud from '../../assets/legal_immigration_Assistance/fraud_dispute.jpg';
import legalImmigration from '../../assets/legal_immigration_Assistance/immigration.jpg';
import afTax from '../../assets/accounting_financial_Services/tax-credits-claim-return-deduction-refund-concept.jpg';
import afInsurance from '../../assets/accounting_financial_Services/insurance.jpg';
import afBusiness from '../../assets/accounting_financial_Services/business_Services.jpg';
import afFinancial from '../../assets/accounting_financial_Services/financial_Services.jpg';
import vmBuy from '../../assets/vehicle_marketplace/buy_vehicle.jpg';
import vmSell from '../../assets/vehicle_marketplace/sell_vehicle.jpg';
import vmFinancing from '../../assets/vehicle_marketplace/financing_vehicle.jpg';
import vmTradeIn from '../../assets/vehicle_marketplace/trade_in.jpg';
import paRcic from '../../assets/professionals_available/lawyer-signing-legal-documents.jpg';
import paLawyer from '../../assets/professionals_available/lawyers.jpg';
import paAccountant from '../../assets/professionals_available/accountants.jpg';
import paParalegal from '../../assets/professionals_available/paralegals.jpg';
import svcFirearm from '../../assets/shooting-range-safety-officer-demonstrating-how-safely-reload-firearms.jpg';
import svcTax from '../../assets/pexels-n-voitkevich-6863191.jpg';
import type { PublicHomeItem } from './appContentService';

const HOME_ITEM_IMAGES: Record<string, string> = {
  'emergency:accident-help': emergAccident,
  'emergency:roadside-assist': emergRoadside,
  'emergency:towing': emergTowing,
  'emergency:vehicle-lockout': emergLockout,
  'legal:legal-consult': legalConsultation,
  'legal:traffic-ticket': legalTraffic,
  'legal:fraud-disputes': legalFraud,
  'legal:immigration': legalImmigration,
  'financial:tax-services': afTax,
  'financial:insurance': afInsurance,
  'financial:business-services': afBusiness,
  'financial:financial-svcs': afFinancial,
  'vehicle:buy-vehicle': vmBuy,
  'vehicle:sell-vehicle': vmSell,
  'vehicle:financing': vmFinancing,
  'vehicle:trade-in': vmTradeIn,
  'professionals:rcic': paRcic,
  'professionals:lawyers': paLawyer,
  'professionals:accountants': paAccountant,
  'professionals:paralegals': paParalegal,
};

const STORE_IMAGES: Record<string, string> = {
  'canadian-firearm-course': svcFirearm,
  'individual-tax-filing': svcTax,
};

export function resolveHomeItemImage(item: PublicHomeItem): string | undefined {
  if (item.image_url?.trim()) return item.image_url;
  return HOME_ITEM_IMAGES[`${item.categoryId}:${item.slug}`];
}

export function resolveStoreProductImage(slug: string, imageUrl?: string): string | undefined {
  if (imageUrl?.trim()) return imageUrl;
  return STORE_IMAGES[slug];
}
